const ConditionOperators = {
    and: 'and',
    or: 'or',
    not: 'not',
    in: 'in',
    between: 'between',
    equals: 'equals',
    gt: 'gt', // greater than
    gte: 'gte', // greater than equal
    lt: 'lt', // lower than
    lte: 'lte', // lower than equal
    inList: 'in-list', // only applicable for lists of values in text filters
    same: 'same', // rules only field to field comparison mode
    contains: 'contains', // for array fields like `planIds`
    random: 'rand', // special operator
};

export default ConditionOperators;
